var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirportManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:flight-roster"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 15C28 14.4872 27.5843 14.0714 27.0714 14.0714H22.3636C22.1551 12.4376 21.4101 10.9192 20.2454 9.75458C19.0808 8.58992 17.5624 7.8449 15.9286 7.63643V2.92857C15.9286 2.41574 15.5128 2 15 2C14.4872 2 14.0714 2.41574 14.0714 2.92857V7.63643C12.4376 7.8449 10.9192 8.58992 9.75458 9.75458C8.58992 10.9192 7.8449 12.4376 7.63643 14.0714H2.92857C2.41574 14.0714 2 14.4872 2 15C2 15.5128 2.41574 15.9286 2.92857 15.9286H7.63643C7.8449 17.5624 8.58992 19.0808 9.75458 20.2454C10.9192 21.4101 12.4376 22.1551 14.0714 22.3636V27.0714C14.0714 27.5843 14.4872 28 15 28C15.5128 28 15.9286 27.5843 15.9286 27.0714V22.3636C17.5624 22.1551 19.0808 21.4101 20.2454 20.2454C21.4101 19.0808 22.1551 17.5624 22.3636 15.9286H27.0714C27.5843 15.9286 28 15.5128 28 15ZM15 20.5714C13.8981 20.5714 12.8209 20.2447 11.9047 19.6325C10.9885 19.0203 10.2744 18.1501 9.85267 17.1321C9.43098 16.114 9.32065 14.9938 9.53562 13.9131C9.7506 12.8323 10.2812 11.8396 11.0604 11.0604C11.8396 10.2812 12.8323 9.7506 13.9131 9.53562C14.9938 9.32065 16.114 9.43098 17.1321 9.85267C18.1501 10.2744 19.0203 10.9885 19.6325 11.9047C20.2447 12.8209 20.5714 13.8981 20.5714 15C20.5697 16.4771 19.9822 17.8932 18.9377 18.9377C17.8932 19.9822 16.4771 20.5697 15 20.5714Z",
    fill: "#4A4A4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportManagement);
export default __webpack_public_path__ + "static/media/airport-management.097766a1eeb6f2ab28aeca705674320e.svg";
export { ForwardRef as ReactComponent };